export const setList = (state, payload) => state.list = payload;

export const setTypes = (state, payload) => state.types = payload;

export const setMetaCommon = (state, payload) => state.metaCommon = payload;

export const setDocument = (state, payload) => state.document = payload;

export const setComments = (state, payload) => state.comments = payload;

export const setSharedDocument = (state, payload) => state.sharedDocument = payload;

export const setUnlockSharedDocument = (state, payload) => state.unlockSharedDocument = payload;

export const setApprovedDocument = (state, payload) => state.document.approve = payload;

export const setBulkUploadList = (state, payload) => state.bulkUploadList = payload;

export const setBulkUploadItem = (state, payload) => state.bulkUploadItem = payload;

export const setDraftDocuments = (state, payload) => state.draftDocuments = payload;

export const setCategories = (state, payload) => state.categories = payload;

export const setDraftDocumentItem = (state, payload) => state.draftDocumentItem = payload;

export const setDownloadHistory = (state, payload) => state.downloads= payload;

export const updateDocumentShare = (state, shareData) => {
  if(shareData) {
    state.document.is_shared = shareData.document.is_shared;
    state.document.share = shareData.document.share;
  } else {
    state.document.is_shared = false;
    state.document.share = null;
  }
}

export const setdashboardDocumentData = (state, payload) => state.dashboardDocumentData= payload;